import * as React from "react";
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const CheveronLeftCircleIcon = ({
  fill,
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 44 44"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-5 relative"
    {...restProps}
  >
    <path
      fill={fill}
      className={`fill-primary dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:fill-primary"
      }`}
      fillRule="evenodd"
      d="M25.5312 33.5938C25.3548 33.5939 25.18 33.5592 25.017 33.4917C24.8539 33.4241 24.7058 33.325 24.5812 33.2L13.8312 22.45C13.7064 22.3253 13.6073 22.1772 13.5397 22.0142C13.4722 21.8512 13.4374 21.6765 13.4374 21.5C13.4374 21.3235 13.4722 21.1488 13.5397 20.9858C13.6073 20.8228 13.7064 20.6747 13.8312 20.55L24.5812 9.79997C25.1063 9.2749 25.9565 9.2749 26.4813 9.79997C27.006 10.325 27.0064 11.1753 26.4813 11.7L16.6813 21.5L26.4813 31.3C26.6061 31.4247 26.7052 31.5728 26.7728 31.7358C26.8403 31.8988 26.8751 32.0735 26.8751 32.25C26.8751 32.4265 26.8403 32.6012 26.7728 32.7642C26.7052 32.9272 26.6061 33.0753 26.4813 33.2C26.3567 33.325 26.2086 33.4241 26.0455 33.4917C25.8825 33.5592 25.7077 33.5939 25.5312 33.5938ZM43 21.5C43 9.6451 33.3549 0 21.5 0C9.6451 0 0 9.6451 0 21.5C0 33.3549 9.6451 43 21.5 43C33.3549 43 43 33.3549 43 21.5ZM40.3125 21.5C40.3125 31.8734 31.8734 40.3125 21.5 40.3125C11.1266 40.3125 2.6875 31.8734 2.6875 21.5C2.6875 11.1266 11.1266 2.6875 21.5 2.6875C31.8734 2.6875 40.3125 11.1266 40.3125 21.5Z"
    />
  </svg>
);
export default CheveronLeftCircleIcon;
